import Vue from "vue";
import Vuex from "vuex";
import timelineService from "../api/timeline";

Vue.use(Vuex);

const initialState = {
  timelines: [],
  timelinesLoading: false,
};

const getters = {
  timelines(state) {
    return state.timelines;
  },
  timelinesLoading(state) {
    return state.timelinesLoading;
  },
};

export const actions = {
  async getTimelineByPersonId(context, payload) {
    try {
      context.state.timelinesLoading = true;
      const response = await timelineService.getTimelineByPersonId(payload);
      context.state.timelines = response.data.timelines;
      context.state.timelines.forEach(element => {
        element.assets = element.assets.map((el, index) => {
          return {
            value: el.entityId,
            text: el.assetName, // || 'assetUrl' + index,
            type: el.type,
            assetName: el.assetName,
            url: el.assetUrl,
          }
        });
      });
      
      context.state.timelinesLoading = false;
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      context.state.timelinesLoading = false;
      return Promise.reject(error);
    }
  },
  async addTimeline(context, payload) {
    try {
      const response = await timelineService.addTimeline(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.addTimeline,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async editTimeline(context, payload) {
    try {
      const response = await timelineService.editTimeline(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.editTimeline,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async deleteTimeline(context, payload) {
    try {
      const response = await timelineService.deleteTimeline(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.deleteTimeline,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
};

export const state = { ...initialState };

export default {
  namespaced: true,
  state,
  getters,
  actions,
};
